import { CustomSignupFieldTypes, CustomSignupField } from '@shared/welibrary-graphql/types';

export const filterSignupQuestions = (questions: CustomSignupField[]) => {
    return questions?.filter(
        question => question.showOnSignup && question.type !== CustomSignupFieldTypes.ChooseRole
    );
};

export default filterSignupQuestions;
